import "./sentry";
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
// Import i18n configuration (must be before App)
import "./i18n";
// Import Ant Design locale
import { ConfigProvider } from "antd";
import plPL from "antd/locale/pl_PL";
import dayjs from "dayjs";
import "dayjs/locale/pl";

dayjs.locale("pl");

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <ConfigProvider locale={plPL}>
    <App />
  </ConfigProvider>
);
